export default "__VITE_ASSET__EYlisrwK__"